import { render } from "./ToggleableButton.vue?vue&type=template&id=2636c45a&scoped=true&ts=true"
import script from "./ToggleableButton.vue?vue&type=script&lang=ts"
export * from "./ToggleableButton.vue?vue&type=script&lang=ts"

import "./ToggleableButton.vue?vue&type=style&index=0&id=2636c45a&lang=scss"
import "./ToggleableButton.vue?vue&type=style&index=1&id=2636c45a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2636c45a"]])

export default __exports__